$shm_agent_history $mol_book2
	catalog_items /any
	detail null
	selected? \
	has_more false
	load_more? null
	close? null
	agent_title \Агент
	Close_icon $mol_icon_close
	pages <= history_pages /$mol_view
	Catalog $mol_page
		title \История сообщений
		tools /
			<= Catalog_close $mol_button_minor
				hint \Закрыть историю
				sub / <= Close_icon
				click? <=> close? null
		body /
			<= Catalog_list $mol_list
				rows <= catalog_rows /$mol_view
	Catalog_link* $mol_link
		arg <= catalog_arg* *
		current <= catalog_current* false
		click? <=> catalog_select*? null
		sub /
			<= Catalog_text* $mol_view
				sub / <= catalog_text* \
			<= Catalog_time* $mol_view
				sub / <= catalog_time* \
	Catalog_more $mol_button_minor
		title \Загрузить предыдущие
		click? <=> load_more? null
	Catalog_empty $mol_view
		sub / \Сообщений пользователя нет
	Detail $mol_page
		title <= detail_title \Сообщение
		tools /
			<= Detail_close $mol_button_minor
				hint \Закрыть историю
				sub / <= Close_icon
				click? <=> close? null
		body /
			<= Detail_body $mol_view
				sub <= detail_sections /$mol_view
	User_panel $mol_view
		sub /
			<= User_scroll $mol_scroll
				sub /
					<= User_messages $mol_view
						sub /
							<= User_message $shm_agent_message_card
								role_key \userMessage
								role \Вы
								time <= user_time \
								text <= user_text \
								content /
									<= User_text $shm_agent_message_text
										text <= user_text \
	Previous_panel $mol_view
		sub /
			<= Previous_list $mol_scroll
				sub /
					<= Previous_messages $mol_view
						sub <= previous_rows /$mol_view
	Previous_message* $shm_agent_message_card
		message_theme \$mol_theme_special
		role_key \agentMessage
		role <= agent_title
		time <= previous_time* \
		text <= previous_text* \
		content /
			<= Previous_text* $shm_agent_message_text
				text <= previous_text* \
	Last_panel $mol_view
		sub /
			<= Last_scroll $mol_scroll
				sub /
					<= Last_messages $mol_view
						sub <= last_rows /$mol_view
	Last_message $shm_agent_message_card
		message_theme \$mol_theme_special
		role_key \agentMessage
		role <= agent_title
		time <= last_time \
		text <= last_text \
		content /
			<= Last_text $shm_agent_message_text
				text <= last_text \
	No_previous $mol_view
		sub / \Промежуточных ответов нет
	No_answers $mol_view
		sub / \Ответов агента пока нет
